/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_StatusInputs */

const en_shipping_status = /** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipping Status`)
};

const es_shipping_status = /** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado de Envío`)
};

const fr_shipping_status = /** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut d'expédition`)
};

const de_shipping_status = /** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versandstatus`)
};

const id_shipping_status = /** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Pengiriman`)
};

/** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */
const ja_shipping_status = en_shipping_status;

/** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */
const zh_shipping_status = en_shipping_status;

/** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */
const ar_shipping_status = en_shipping_status;

/** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */
const it_shipping_status = en_shipping_status;

/** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */
const ru_shipping_status = en_shipping_status;

/** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */
const pt_shipping_status = en_shipping_status;

/** @type {(inputs: Shipping_StatusInputs) => LocalizedString} */
const ko_shipping_status = en_shipping_status;

/**
* | output |
* | --- |
* | "Shipping Status" |
*
* @param {Shipping_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shipping_status = /** @type {((inputs?: Shipping_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shipping_status(inputs)
	if (locale === "es") return es_shipping_status(inputs)
	if (locale === "fr") return fr_shipping_status(inputs)
	if (locale === "de") return de_shipping_status(inputs)
	if (locale === "ja") return ja_shipping_status(inputs)
	if (locale === "zh") return zh_shipping_status(inputs)
	if (locale === "ar") return ar_shipping_status(inputs)
	if (locale === "id") return id_shipping_status(inputs)
	if (locale === "it") return it_shipping_status(inputs)
	if (locale === "ru") return ru_shipping_status(inputs)
	if (locale === "pt") return pt_shipping_status(inputs)
	return ko_shipping_status(inputs)
});